import { BaseEntityInfoUtils, EntityInfo } from '@record-it-npm/synchro-common';
import { AppCommonSynchronizationEnvironmentTypes } from '../../../AppCommonSynchronizationEnvironment';
import { EntityName } from '../../../EntityName';
import { CreateEntityInfoOptions } from '../../base/CreateEntityInfoOptions';
import { UserGroupSubEntityInfoUtils } from '../../base/UserGroupSubEntityInfoUtils';
import { UserGroupToUserDto } from './UserGroupToUserDto';
export function createUserGroupToUserEntityInfo<TEntity extends UserGroupToUserDto>(options: CreateEntityInfoOptions<UserGroupToUserDto, TEntity>): EntityInfo<AppCommonSynchronizationEnvironmentTypes, EntityName.UserGroupToUser, TEntity> {
  return {
    entityName: EntityName.UserGroupToUser,
    synchronizeRelativeTo: [],
    trackGlobalRevision: true,
    fieldInfos: BaseEntityInfoUtils.createFieldInfos<AppCommonSynchronizationEnvironmentTypes, UserGroupToUserDto, TEntity>({
      ...UserGroupSubEntityInfoUtils.createBaseFieldInfos(),
      userId: {
        name: 'userId',
        ref: EntityName.User,
        cascadeDeleteLocally: true
      },
      timeTrackingConfigurationId: {
        name: 'timeTrackingConfigurationId',
        ref: EntityName.TimeTrackingConfiguration,
        defaultValue: null
      },
      groupAdmin: {
        name: 'groupAdmin',
        defaultValue: false
      }
    }, options.additionalFieldInfos)
  };
}